import { render, staticRenderFns } from "./task_list.vue?vue&type=template&id=327bbc43&scoped=true"
import script from "./task_list.vue?vue&type=script&lang=js"
export * from "./task_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327bbc43",
  null
  
)

export default component.exports